/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface UsageConfigSpec { 
    /**
     * Usage config name to push.
     */
    key: string;
    vcds_service_type: VcdsServiceTypeEnum;
    /**
     * Usage Type
     */
    usage_type: string;
    required: boolean;
    tenant_visible: boolean;
    billable: boolean;
}
export namespace UsageConfigSpec {
}


